import { Pipe, PipeTransform } from '@angular/core';

export type VolumeUnit = 'gal' | 'L' | 'qt' | 'oz';
export type UnitSelection = 'original' | VolumeUnit;

const OZ_PER: Record<string, number> = {
  oz: 1,
  pt: 16,
  qt: 32,
  L: 33.814,
  gal: 128,
};

export function convertVolume(value: number, fromUnit: string, toUnit: string): number | null {
  if (fromUnit === toUnit) return value;
  const from = OZ_PER[fromUnit];
  const to = OZ_PER[toUnit];
  if (from == null || to == null) return null;
  return (value * from) / to;
}

function formatAmount(num: number | null | undefined): string {
  if (num == null) return '0';
  return num.toLocaleString('en-US', { maximumFractionDigits: 2 });
}

@Pipe({ name: 'chemAmount', standalone: true, pure: true })
export class ChemAmountPipe implements PipeTransform {
  transform(value: number | null | undefined, fromUnit: string, target: UnitSelection): string {
    if (value == null) return '0';
    if (target === 'original') return `${formatAmount(value)} ${fromUnit}`;
    const converted = convertVolume(value, fromUnit, target);
    if (converted == null) return `${formatAmount(value)} ${fromUnit}`;
    return `${formatAmount(converted)} ${target}`;
  }
}
